export enum HintId {
	ShopPriceList = 0,
	OfferRequestsMenu = 1,
}
